_getUserLocalData